var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGithubIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,0.8c-17.6,0-32,14.3-32,32c0,14.1,9.2,26.1,21.9,30.4c1.6,0.3,2.2-0.7,2.2-1.5c0-0.7,0-2.8-0.1-5.5 c-8.9,2-10.8-4.3-10.8-4.3c-1.5-3.7-3.6-4.6-3.6-4.6c-2.9-2,0.2-2,0.2-2c3.2,0.2,4.9,3.3,4.9,3.3c2.8,4.9,7.5,3.5,9.3,2.6 c0.3-2.1,1.1-3.5,2-4.3c-7-0.7-14.5-3.5-14.5-15.7c0-3.5,1.3-6.3,3.3-8.5c-0.3-0.8-1.4-4,0.3-8.5c0,0,2.7-0.9,8.8,3.3 c2.6-0.7,5.3-1.1,8-1.1s5.5,0.3,8,1.1c6.1-4.1,8.7-3.3,8.7-3.3c1.7,4.4,0.7,7.7,0.3,8.5c2,2.2,3.3,5.1,3.3,8.5 c0,12.2-7.5,15-14.6,15.7c1.1,1,2.2,3,2.2,5.9c0,4.3-0.1,7.7-0.1,8.7c0,0.9,0.6,1.8,2.2,1.5C54.8,58.8,64,46.8,64,32.7 C63.9,15.1,49.6,0.8,32,0.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIcon);
export default __webpack_public_path__ + "static/media/github-icon.b37d01ffe01bfe347f66050308e8570e.svg";
export { ForwardRef as ReactComponent };